import axios from "@/axios.js";

export default {
  addRole({ commit }, role) {
    return new Promise((resolve, reject) => {
      axios
        .post("roles", role)
        .then((response) => {
          commit("ADD_ROLE", role);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchRoles({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get("roles", { params: param })
        .then((response) => {
          const data = response.data.data;
          if (data && data.pagination)
            commit("SET_ROLES_WITH_PAGINATION", response.data.data);
          else commit("SET_ROLES", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateRole({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .put(`roles/${item.id}`, item)
        .then((response) => {
          commit("UPDATE_ROLE", item);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  removeRecord({ commit }, roleId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`roles/${roleId}`)
        .then((response) => {
          commit("REMOVE_RECORD", roleId);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  fetchPermissions({ commit }, param) {
    return new Promise((resolve, reject) => {
      axios
        .get("permissions", { params: param })
        .then((response) => {
          commit("SET_PERMISSION", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  setPagination({ commit }, page) {
    commit("SET_PAGINATION", page);
  },
};
